import React, { createContext, useContext, useState, useRef } from "react";
import { storage } from "../utils/storage";

const VendorMenuContext = createContext();
const VENDOR_MENU_STORAGE_KEY = 'vendor_menu_data';

export const useVendorMenu = () => useContext(VendorMenuContext);

export const VendorMenuProvider = ({ children }) => {
  const [menuData, setMenuData] = useState(() => storage.get(VENDOR_MENU_STORAGE_KEY) || {});
  const isUpdating = useRef(false);

  const updateVendorMenu = (vendorId, groupedMenu) => {
    if (isUpdating.current) return;
    isUpdating.current = true;

    try {
      const newMenuData = {
        ...menuData,
        [vendorId]: groupedMenu,
      };
      setMenuData(newMenuData);
      storage.set(VENDOR_MENU_STORAGE_KEY, newMenuData);
    } catch (error) {
      console.error('Error updating vendor menu:', error);
    } finally {
      isUpdating.current = false;
    }
  };

  const refreshVendorMenu = () => {
    setMenuData({});
    storage.remove(VENDOR_MENU_STORAGE_KEY);
  };

  return (
    <VendorMenuContext.Provider value={{ menuData, updateVendorMenu, refreshVendorMenu }}>
      {children}
    </VendorMenuContext.Provider>
  );
};
